export enum UserRoleName {
  platformAdministrator = 'platform_administrator',
  builderAdministrator = 'builder_administrator',
  divisionAdministrator = 'division_administrator',
  administrator = 'community_administrator',
  user = 'user'
}
